import { currentSessionSchema } from '../../../../server/src/auth/session.contracts';
import { apiRequest, emptyResponseSchema } from '../http';

export function currentSession() { return apiRequest('/auth/me', currentSessionSchema); }
export function logout() { return apiRequest('/auth/logout', emptyResponseSchema, { method: 'POST' }); }
export function discardPlayerSession(token: string) { return apiRequest('/auth/logout', emptyResponseSchema, { method: 'POST', auth: false, token }); }
